
export const onChangeState = ({state, onChange}) => ({
    value: state.value,
    onChange: (v) => {
        onChange();
        return state.onChange(v);
    },
    change: (fn) => {
        onChange();
        return state.change(fn);
    },
});
